import * as React from 'react';

import { closeButtonCss, headerBaseCss, titleCss } from './styles';

export interface ModalHeaderProps {
  className?: string;
  children?: React.ReactNode;
  tag?: React.ElementType;
  wrapTag?: React.ElementType;
  toggle?: (e?: React.MouseEvent) => void;
  closeAriaLabel?: string;
  charCode?: string | number;
  close?: React.ReactNode;
}

const ModalHeader = ({
  className,
  children,
  toggle,
  tag: Tag = 'h5',
  wrapTag: WrapTag = 'div',
  closeAriaLabel = 'Close',
  charCode = 215,
  close
}: ModalHeaderProps): React.JSX.Element => {
  let closeButton: React.ReactNode = null;
  if (!close && toggle) {
    const closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
    closeButton = (
      <button type="button" onClick={toggle} css={closeButtonCss} aria-label={closeAriaLabel}>
        <span aria-hidden="true">{closeIcon}</span>
      </button>
    );
  }

  return (
    <WrapTag css={headerBaseCss} className={className}>
      <Tag css={titleCss}>{children}</Tag>
      {close || closeButton}
    </WrapTag>
  );
};

export default ModalHeader;
